module.exports = __webpack_public_path__ + "img/card2.442f5313.png";